import React from 'react';
import '../DashboardSkeleton.css';
import './AnswerSheetShimmer.css';

const Line = ({ className = '' }) => <span className={`dashboard-skeleton answer-sheet-shimmer__line ${className}`} />;

export function AnswerSheetSidebarShimmer({ actionCount = 2 }) {
  return <div role="status" aria-label="Loading answer sheet summary">
    <span className="visually-hidden">Loading answer sheet summary...</span>
    <div aria-hidden="true">
      <Line className="answer-sheet-shimmer__title" />
      <Line className="answer-sheet-shimmer__subtitle" />
      <div className="quizAnswer-stats">
        {[0, 1, 2].map((row) => <div key={row} className="answerSheet-statRow"><Line /><Line className="answer-sheet-shimmer__value" /></div>)}
      </div>
      <div className="answerSheet-sidebarButtons">
        {Array.from({ length: actionCount }, (_, index) => <Line key={index} className="answer-sheet-shimmer__button" />)}
      </div>
      <div className="answerSheet-filterSection">
        <Line className="answer-sheet-shimmer__title" />
        <div className="answerSheet-filterGrid" data-testid="answer-filter-shimmer">
          {[0, 1, 2, 3].map((filter) => <Line key={filter} className="answer-sheet-shimmer__filter" />)}
        </div>
      </div>
    </div>
  </div>;
}

export function AnswerTabsShimmer({ hideTabs = false }) {
  return <div className="quiz-result-page" role="status" aria-label="Loading answer sheet questions">
    <span className="visually-hidden">Loading answer sheet questions...</span>
    <div className="quiz-result-container" aria-hidden="true">
      {!hideTabs && <div className="quiz-question-tabs" data-testid="answer-tabs-shimmer">
        {[0, 1, 2, 3].map((tab) => <Line key={tab} className="answer-sheet-shimmer__tab" />)}
      </div>}
      <div className="quiz-question-list">
        {[0, 1, 2].map((card) => <div key={card} className="quiz-question-card" data-testid="answer-question-shimmer">
          <div className="quiz-card-header">
            <Line className="answer-sheet-shimmer__status" />
            <Line className="answer-sheet-shimmer__value" />
            <Line className="answer-sheet-shimmer__icon" />
          </div>
          <div className="quiz-question-text"><Line /><Line className="answer-sheet-shimmer__subtitle" /></div>
          <div className="qbank-options">
            {[0, 1, 2, 3].map((option) => <div key={option} className="qbank-option">
              <Line className="answer-sheet-shimmer__icon" /><Line />
            </div>)}
          </div>
          <div className="markGuess qbank-guess"><Line className="answer-sheet-shimmer__status" /></div>
          <div className="qbank-sideCard">
            <div className="qbank-sideCard__head"><Line className="answer-sheet-shimmer__status" /><Line className="answer-sheet-shimmer__icon" /></div>
            <div className="qbank-sideCard__body"><Line /><Line className="answer-sheet-shimmer__subtitle" /></div>
          </div>
          <div className="qbl-questionCard__footer">
            {[0, 1, 2, 3].map((action) => <Line key={action} className="answer-sheet-shimmer__action" />)}
          </div>
        </div>)}
      </div>
    </div>
  </div>;
}
